import { OFooter } from "@dnvgl-onefoundation/onedesign-react";


const Footer = () => {
  return (
    <div className="container footer-container">
      <OFooter fluid small={true} className="fixed-bottom"></OFooter>
    </div>
  );
};

export default Footer;
